import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const sliders = document.querySelectorAll("[data-testimonials-slider]");

	if (!sliders.length) return;

	sliders.forEach(function (sliderEl) {
		if (sliderEl.classList.contains("is-initialized")) return;
		sliderEl.classList.add("is-initialized");

		const splide = new Splide(sliderEl, {
			type: "loop",
			fixedWidth: "330px",
			perMove: 1,
			gap: "2.4rem",
			focus: "center",
			trimSpace: false,
			autoHeight: true,
			arrows: false,
			pagination: false,
			mediaQuery: "min",
			breakpoints: {
				768: {
					fixedWidth: "475px",
				},
				1200: {
					fixedWidth: "630px",
				},
			},
		});

		splide.mount();

		// Wire custom arrows
		const container = sliderEl.closest(".testimonials-block");
		if (!container) return;

		container
			.querySelectorAll(".testimonials-block__arrow.--prev")
			.forEach(function (btn) {
				btn.addEventListener("click", function () {
					splide.go("<");
				});
			});

		container
			.querySelectorAll(".testimonials-block__arrow.--next")
			.forEach(function (btn) {
				btn.addEventListener("click", function () {
					splide.go(">");
				});
			});
	});
});
